import React, { useState, useEffect, useMemo } from "react";
import * as apicall from '../../components/Apicall';
import { IoArrowBack } from "react-icons/io5";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { FaSearch } from "react-icons/fa";
import { Form, InputGroup, DropdownButton, Dropdown } from 'react-bootstrap';
import '../../App.css'
import DatePicker from "react-datepicker";
import { format, parseISO } from 'date-fns';

const vendor_payout =[
    "Yes",
    "No"
]

const UserFollowup = () => {
      const location = useLocation();
 const [allBookings, setAllBookings] = useState([]); 
const [bookings, setBookings] = useState([]);    
  const [selectedIds, setSelectedIds] = useState([]);
  const [expandedUsers, setExpandedUsers] = useState({});
  const [selectedUserId, setSelectedUserId] = useState(null);
  // The booking this edit form actually targets — backend keys
  // user_followup_details by booking_id (not user_id, see the "followup"
  // handler's own comment on why), so Save has to know which one. Defaults
  // to the user's first/most recent booking, same row the summary table
  // above already reads its followup_* columns from.
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [payoutFilter, setPayoutFilter] = useState(null);
    const [followUpList,setFollowUpList]=useState()
        const [followupResponse,setFollowupResponse]=useState()
    const [followUp,setFollowUp]=useState()
        const [followUpres,setFollowUpRes]=useState()
    const [contactDetails, setContactDetails] = useState();
  
const [selectedUserBookings, setSelectedUserBookings] = useState([]);
  const [form, setForm] = useState({
    followup_date: "",
    followup_details : "",
    followup:"",
    contact:"",
    followup_res:"",
    comments:""
  });
  const [sortConfig, setSortConfig] = useState({
  key: null,
  direction: "asc",
});
const handleSort = (key) => {
  setSortConfig((prev) => {
    if (prev.key === key) {
      return {
        key,
        direction: prev.direction === "asc" ? "desc" : "asc",
      };
    }
    return { key, direction: "asc" };
  });
};
const renderArrow = (key) => {
  if (sortConfig.key === key) {
    return (
      <span className="sort-icon">
        {sortConfig.direction === "asc" ? "▲" : "▼"}
      </span>
    );
  }
  return <span className="sort-icon">▲▼</span>;
};

  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  const today = new Date().toISOString().split("T")[0];

const formatDate = (date) => {
  if (!date) return "";
  // new Date(x).toISOString() round-trips a date-only value through UTC,
  // which can roll it back/forward a day (or, compounded across repeated
  // save→reselect cycles, drift further each time) depending on the
  // browser's timezone offset from the server. If the value already starts
  // with YYYY-MM-DD (a plain date, or a full DATETIME string from MySQL),
  // take that prefix directly instead of reparsing it as a Date.
  const match = String(date).match(/^\d{4}-\d{2}-\d{2}/);
  if (match) return match[0];
  const d = new Date(date);
  return isNaN(d.getTime()) ? "" : d.toISOString().split("T")[0];
};

const [startDate, setStartDate] = useState(formatDate(today));
const [endDate, setEndDate] = useState(formatDate(today));


const handleUserSelect = (userId) => {
  const numericUserId = Number(userId);
  setSelectedUserId(numericUserId);
  const records = groupedData[numericUserId] || [];
  setSelectedUserBookings(records);

  // Load this user's already-saved follow-up data into the form instead of
  // leaving whatever was typed for the previously-selected user sitting
  // there — that stale/blank state is what was wiping out real values on
  // the next Save (see followup_details/contact/etc below).
  const firstRecord = records[0];
  setSelectedBookingId(firstRecord?.Booking_ID ?? null);
  setFollowUp(firstRecord?.followup_details || "");
  setFollowUpRes(firstRecord?.followup_response || "");
  setForm({
    followup_date: formatDate(firstRecord?.followup_date) || today,
    followup_details: firstRecord?.followup_details || "",
    followup: firstRecord?.followup || "",
    contact: firstRecord?.utilstop_contact || "",
    followup_res: firstRecord?.followup_response || "",
    comments: firstRecord?.comments || "",
  });
};

const handleViewOrder = (id) => {
  window.open(`/bookingDetails/${id}`, "_blank"); 
};

        const navigate = useNavigate();
  useEffect(() => {
      if (!form.followup_date) {
    setForm(prev => ({ ...prev, followup_date: today }));
  }

    fetchContactDetails();
    fetchBookings();
    fetchFeedback();
    
  }, []);
const vendor_payout_details = ["Yes", "No", "(Blank)"];

const applyFilters = (payout) => {
  let filtered = allBookings;

  if (payout) {
    if (payout === "(Blank)") {
      filtered = filtered.filter(
        (item) => !item.followup || item.followup.trim() === ""
      );
    } else {
      filtered = filtered.filter(
        (item) =>
          (item.followup || "").toLowerCase() === payout.toLowerCase()
      );
    }
  }
  setBookings(filtered);
  //  const userExists = filtered.some((item) => Number(item.user_id) === Number(selectedUserId));
  //  console.log(userExists,"userExists")
  // if (!userExists) {
  //   setSelectedUserId(null);
  //   setSelectedUserBookings([]);
  // }
};

const clearAllFilters = () => {
  const defaultStartDate = formatDate(today);
  const defaultEndDate = formatDate(today);
  setPayoutFilter(null);
  setStartDate(defaultStartDate);
  setEndDate(defaultEndDate);
  fetchBookings(defaultStartDate, defaultEndDate);
};
const fetchBookings = async (start,end) => {
  const start_str = formatDate(start);
    const end_str = formatDate(end);
  try {
     const startStr = formatDate(start_str|| startDate);
    const endStr = formatDate(end_str || endDate);

     let url = "get_user_pending_details";
    
        if (startStr && endStr) {
          url += `?startDate=${startStr}&endDate=${endStr}`;
        }
    
        const res = await apicall.get(url);
        setAllBookings(res.data);
        setBookings(res.data);
  } catch (e) {
    toast.error(e.message.replace("Error:", ""));
  }
};
const fetchContactDetails = async () => {
  try {
    const res = await apicall.get(`/get_contact`);
    setContactDetails(res?.data)
    
  } catch (err) {
    toast.error("Failed to fetch feedback details: " + err.message);
  }
};
const groupedData = useMemo(() => {
  const groups = {};
  bookings.forEach((record) => {
    const key = String(record.user_id);
    if (!groups[key]) groups[key] = [];
    groups[key].push(record);
  });

  return groups;
}, [bookings]);
const sortedGroupedData = useMemo(() => {
  const entries = Object.entries(groupedData);

  if (!sortConfig.key) return entries;

  return [...entries].sort(([, aRecords], [, bRecords]) => {
    const a = aRecords[0];
    const b = bRecords[0];

    let valA, valB;

    switch (sortConfig.key) {
      case "name":
        valA = a.first_name || "";
        valB = b.first_name || "";
        break;

      case "followup_details":
        valA = a.followup_details || "";
        valB = b.followup_details || "";
        break;

      case "followup_date":
        valA = a.followup_date ? new Date(a.followup_date) : new Date(0);
        valB = b.followup_date ? new Date(b.followup_date) : new Date(0);
        break;

      default:
        return 0;
    }

    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });
}, [groupedData, sortConfig]);
  const toggleExpand = (userId) => {

    setExpandedUsers((prev) => (prev === userId ? null : userId));
  };

const handleSelect = (id) => {
  setSelectedIds((prev) =>
    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  );
};

const handleSelectAll = (records) => {
  const recordIds = records.map((r) => r.Booking_ID);
  const allSelected = recordIds.every((id) => selectedIds.includes(id));

  setSelectedIds((prev) =>
    allSelected
      ? prev.filter((id) => !recordIds.includes(id)) // unselect all
      : [...prev, ...recordIds.filter((id) => !prev.includes(id))] // select all
  );
};
const handleUpdate = async () => {
  try {
    if (!selectedUserId) {
      toast.error("Please select a user first!");
      return;
    }

    if (!selectedBookingId) {
      toast.error("No booking found for this user to attach the follow-up to!");
      return;
    }

    const payload = {
      user_id: selectedUserId,
      booking_id: selectedBookingId,
      followup_details: followUp,
      followup_date: form.followup_date,
      followup: form.followup,
      contact:form.contact,
      followup_res:followUpres,
      comments:form.comments,
    };
    const res = await apicall.post(payload,"update-followup");

    toast.success("Updated successfully!");
    window.location.reload(); 

    // Without this, `bookings`/`allBookings` stay frozen at whatever was
    // fetched on page load — so the summary table above and the next
    // handleUserSelect() prefill both keep showing the pre-save snapshot
    // forever, even though the write above did succeed. This is what made
    // a real, successful update look like it "didn't take."
    await fetchBookings();
    setSelectedUserId(null);
    setSelectedBookingId(null);

  } catch (err) {
    console.error("Update error:", err);
    toast.error("Update Failed!")
  }
};

useEffect(() => {
  if (selectedUserId) {
    const updatedRecords = groupedData[selectedUserId] || [];
    if (updatedRecords.length > 0) {
      setSelectedUserBookings(updatedRecords);
    } else {
      setSelectedUserId(null);
      setSelectedUserBookings([]);
    }
  }
}, [groupedData, selectedUserId]);

const fetchFeedback = async () => {
  try {
    const res = await apicall.get(`/feedback_details`);
    if (res?.data) {
      const feedbackList = res?.data;

      const followup = feedbackList?.filter(f => f.category === "FollowUp-Details"); 
      const followup_response = feedbackList?.filter(f => f.category === "response"); 
      setFollowUpList(followup) 
      setFollowupResponse(followup_response)       
    }
  } catch (err) {
    toast.error("Failed to fetch feedback details: " + err.message);
  }
};
  return (
    
    <div className="container my-4 p-3 bg-white rounded-3">

  <div className="mb-3 d-flex align-items-center">
    <h1 className="sub-heading mb-0">User Follow-Up Details</h1>
  </div>
    <div className="d-flex justify-content-between align-items-center mb-3">
                     <div className="d-flex gap-3 align-items-center">
  
 <DropdownButton
  id="payout-filter"
  variant="outline-secondary"
  title={payoutFilter || "Select Follow-up"}
>
  {vendor_payout_details.map((status) => (
    <Dropdown.Item
      key={status}
      active={status === payoutFilter}
      onClick={() => {
        setPayoutFilter(status);
        applyFilters(status);
      }}
    >
      {status === "(Blank)" ? "(Blank)" : status}
    </Dropdown.Item>
  ))}
{/* 
  <Dropdown.Divider />
  <Dropdown.Item
    onClick={() => {
      setPayoutFilter("");
      setBookings(allBookings);
    }}
  >
    Show All
  </Dropdown.Item> */}
</DropdownButton>


  </div>
  
                  </div>

                <div className="d-flex gap-4 mb-4 align-items-end w-100 flex-wrap">
                <div>
                    <label htmlFor="startDate" className="form-label">Start Date</label>
                    <input
                        type="date"
                        id="startDate"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="form-control"
                    />
                </div>

                <div>
                    <label htmlFor="endDate" className="form-label">End Date</label>
                    <input
                        type="date"
                        id="endDate"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="form-control"
                    />
                </div>

                {/* <div>
                    <button
                        className="btn"
                        onClick={fetchBookings}
                        style={{
                            background: "#d01c4c",
                            minWidth: "80px",
                            height: "40px",
                            marginTop: "30px",
                            color: "white"
                        }}
                    >
                        Apply
                    </button>
                      <button
      className="btn btn-outline-secondary"
      onClick={clearAllFilters}
    >
      Clear All
    </button>
                </div> */}
                  <div className="d-flex gap-2 mt-3">
  <button
    className="btn"
    onClick={fetchBookings}
    style={{
      background: "#d01c4c",
      minWidth: "80px",
      height: "40px",
      color: "white"
    }}
  >
    Apply
  </button>

  <button
    className="btn btn-outline-secondary"
    onClick={clearAllFilters}
    style={{ minWidth: "80px", height: "40px" }}
  >
    Clear All
  </button>
</div>
                </div>
            

<div
  className="table-responsive border rounded mt-5"
  style={{ maxHeight: "400px", overflowY: "auto" }}
>
          <table className="table table-striped">
<thead>
  <tr>
    <th></th>

    <th
      style={{ cursor: "pointer" }}
      onClick={() => handleSort("name")}
    >
      User Name{renderArrow("name")}
    </th>

    <th>Phone Number</th>

    <th
      style={{ cursor: "pointer" }}
      onClick={() => handleSort("followup_details")}
    >
      Follow-up Details{renderArrow("followup_details")}
    </th>

    <th
      style={{ cursor: "pointer" }}
      onClick={() => handleSort("followup_date")}
    >
      Follow-up Date{renderArrow("followup_date")}
    </th>

    <th>Follow-up</th>
    <th>Utilstop Contact</th>
    <th>Follow-up Response</th>
    <th>Comments</th>
  </tr>
</thead>

<tbody>
  {sortedGroupedData.map(([userId, records]) => {
    const firstRecord = records[0];
    const isSelected = selectedUserId === Number(userId);

    return (
      <tr
        key={userId}
        style={{
          backgroundColor: isSelected ? "#f0f8ff" : "transparent",
        }}
      >
        <td>
          <input
            type="radio"
            name="userSelect"
            checked={isSelected}
            onChange={() => handleUserSelect(userId)}
          />
        </td>

        <td>{firstRecord.first_name}</td>
        <td>{firstRecord.phone_number}</td>
        <td>{firstRecord.followup_details || "null"}</td>
        <td>
          {firstRecord.followup_date
            ? format(parseISO(firstRecord.followup_date), "dd-MM-yyyy")
            : "null"}
        </td>
        <td>{firstRecord.followup || "null"}</td>
        <td>{firstRecord.utilstop_contact || "null"}</td>
        <td>{firstRecord.followup_response || "null"}</td>
         <td>{firstRecord.comments || "null"}</td>

      </tr>
    );
  })}
</tbody>


  </table>
</div>

    <div
    className="table-responsive border rounded mt-5"
    style={{ maxHeight: "400px", overflowY: "auto" }}
  >
  {selectedUserBookings.length > 0 && (
  <table className="table mt-3">
    <thead>
      <tr>
        <th>Booking ID</th>
        <th>Service Name</th>
        <th>Service Type</th>
        <th>Date</th>
        <th>Time</th>
        <th>Amount</th>
        <th>Service State</th>
        <th>Status</th>

      </tr>
    </thead>
    <tbody>
      {selectedUserBookings.map((record) => (
        <tr key={record.Booking_ID}>
            <td>
  <button
    className="btn btn-sm"
    onClick={() => handleViewOrder(record.Booking_ID)}
    style={{
      minWidth: "100px",
      color: "#d01c4c",
    }}
  >
    {record.Booking_ID}
  </button>
</td>

          <td>{record.service_name}</td>
          <td>{record.service_type_name}</td>
          <td>{new Date(record.serviceDate).toLocaleDateString()}</td>
          <td>{record.service_time}</td>
          <td>{record.ServiceAmount_excl_taxes}</td>
          <td>{record.service_state}</td>
          <td>{record.status}</td>

        </tr>
      ))}
    </tbody>
  </table>
)}

  </div>

<div className="mt-4 p-3 border rounded">
  <div className="row g-3 align-items-center">
    
    <div className="col-md-3">
      <label className="form-label">Follow-up Details</label>
      {/* <input
        type="text"
        className="form-control"
        value={form.followup_details}
        onChange={(e) =>
          setForm({ ...form, followup_details: e.target.value })
        }
      /> */}
        <select
          className="form-select"
          onChange={(e) => setFollowUp(e.target.value)}
          value={followUp}
        >
          <option value="">Select follow-up Details</option>
          {followUpList?.map(f => (
            <option key={f.id} value={f.value}>
              {f.value}
            </option>
          ))}
        </select>
    </div>

    <div className="col-md-3">
      <label className="form-label">Follow-up Date</label>
     <input
  type="date"
  className="form-control"
  value={form.followup_date}
  onChange={(e) =>
    setForm({ ...form, followup_date: e.target.value })
  }
/>
    </div>

      <div className="col-md-3">
      <label className="form-label">Follow-up</label>
        <select
          className="form-select"
          value={form.followup}
          onChange={(e) =>
            setForm({ ...form, followup: e.target.value })
          }        >
          <option value="">Select Followup</option>
          {vendor_payout?.map((f) => (
            <option key={f.id} value={f}>
              {f}
            </option>
          ))}
        </select>
    </div>
    <div className="col-md-3">
      <div className="m-2 p-2">
              <label className="form-label">UtilStop Contact</label>
        <select
          className="form-select"
          value={form.contact}
          onChange={(e) =>
            setForm({ ...form, contact: e.target.value })
          } 
        >
          <option value="">Select contact</option>
            <option value={userDetails?.first_name}>
              {userDetails?.first_name}
            </option>
        </select>
      </div>
    </div>
     <div className="col-md-3">
      <label className="form-label">Follow-up Response</label>
  
        <select
          className="form-select"
          onChange={(e) => setFollowUpRes(e.target.value)}
          value={followUpres}
        >
          <option value="">Select follow-up response</option>
          {followupResponse?.map(f => (
            <option key={f.id} value={f.value}>
              {f.value}
            </option>
          ))}
        </select>
    </div>
         <div className="col-md-3">
      <label className="form-label">comments</label>
  
     <input
                        type="text"
                        id="comments"
                        value={form.comments}
                         onChange={(e) =>
    setForm({ ...form, comments: e.target.value })
  }
                        className="form-control"
                    />
    </div>

     {/* <div className="col-md-3">
      <div className="m-2 p-2">
              <label className="form-label">UtilStop Contact</label>
        <select
          className="form-select"
          value={form.contact}
          onChange={(e) =>
            setForm({ ...form, contact: e.target.value })
          } 
        >
          <option value="">Select contact</option>
            <option value={userDetails?.first_name}>
              {userDetails?.first_name}
            </option>
        </select>
      </div>
    </div> */}

   <div className="col-md-12 d-flex justify-content-end">
  <button
    className="btn Button primaryBackground text-white d-flex align-items-center justify-content-center"
    onClick={handleUpdate}
    style={{
      minWidth: "100px",
      fontSize: "14px",
      borderRadius: "6px",
      marginTop:"25px"
    }}
  >
    Save
  </button>
</div>

  </div>
</div>

</div>


  );
};

export default UserFollowup;
